import { viewerBeforeEnter } from '@/router/guards/beforeEach';
import { RouteRecordRaw } from 'vue-router';

export const PatientViewerRoute: RouteRecordRaw = {
  path: 'viewer',
  name: 'viewer',
  beforeEnter: viewerBeforeEnter,
  component: () => import('@/components/layouts/ViewerLayout.vue'),
};
